export default "__VITE_ASSET__CkfzOsOi__"